// 导出页面为PDF格式
import html2canvas from "html2canvas"
import JSPDF from "jspdf"
export default {
	install (Vue, options) {
		Vue.prototype.ExportSavePdf = function (htmlTitle, currentTime) {
			let loading = this.$loading({})
			var element = document.getElementById("pdfCentent").cloneNode(true)
			element.style.position = 'absolute'
			element.style.left = '0'
			element.style.top = '0'
			element.style.margin = '0'
			element.style.zIndex = '-1'
			document.getElementById("app").style.backgroundColor = '#fff'
			document.body.appendChild(element)
			html2canvas(element, {
				useCORS: true,
				width: parseInt(window.getComputedStyle(element).width),
				height: parseInt(window.getComputedStyle(element).height),
				x: 0,
				y: 0
			}).then(function (canvas) {
				var pdf = new JSPDF("l", "mm", "a4") // A4纸，纵向
				var ctx = canvas.getContext("2d")
				var a4w = 257; var a4h = 182
				var imgHeight = Math.floor(a4w * canvas.width / a4h)
				var page = document.createElement("canvas")
				page.width = canvas.width
				page.height = canvas.height
				page.getContext("2d").putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0)


				pdf.addImage(page.toDataURL("image/jpeg", 1.0), "JPEG", 20, 14, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距

				// while (renderedHeight < canvas.height) {
				// 	var page = document.createElement("canvas")
				// 	page.width = canvas.width
				// 	page.height = Math.min(imgHeight, canvas.height - renderedHeight)// 可能内容不足一页
				// 	// 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
				// 	page.getContext("2d").putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0)



				// 	pdf.addImage(page.toDataURL("image/jpeg", 1.0), "JPEG", 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距
				// 	renderedHeight += imgHeight
				// 	if (renderedHeight < canvas.height) { pdf.addPage() }// 如果后面还有内容，添加一个空页
				// 	// delete page;
				// }
				pdf.save(htmlTitle + '_' + currentTime)
				loading.close()
			})
		}
	}
}